import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex align-start justify-space-between flex-wrap ga-4" }
const _hoisted_2 = { style: {"flex":"1","min-width":"240px"} }
const _hoisted_3 = { class: "d-flex align-center ga-3 mb-1" }
const _hoisted_4 = { class: "text-h5 font-weight-bold" }
const _hoisted_5 = { class: "text-body-1 text-medium-emphasis mb-4" }
const _hoisted_6 = { class: "d-flex flex-column ga-2 text-body-2" }
const _hoisted_7 = { class: "d-flex align-center ga-2" }
const _hoisted_8 = { class: "d-flex align-center ga-2" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-start ga-2 mt-1"
}
const _hoisted_10 = { class: "text-medium-emphasis" }
const _hoisted_11 = {
  style: {"min-width":"200px","max-width":"300px","flex":"0 1 auto"},
  class: "text-center"
}
const _hoisted_12 = { class: "d-flex justify-space-between text-caption text-medium-emphasis mt-1" }
const _hoisted_13 = { class: "d-flex align-center ga-2 mb-4" }
const _hoisted_14 = {
  class: "text-center",
  style: {"line-height":"1.25","user-select":"none"}
}
const _hoisted_15 = { class: "text-h5 font-weight-bold" }
const _hoisted_16 = { class: "d-flex align-center ga-2 mb-4" }
const _hoisted_17 = {
  class: "text-center",
  style: {"line-height":"1.25","user-select":"none"}
}
const _hoisted_18 = { class: "text-h5 font-weight-bold" }
const _hoisted_19 = { class: "d-flex align-center ga-2 mb-4" }
const _hoisted_20 = {
  class: "text-center",
  style: {"line-height":"1.25","user-select":"none"}
}
const _hoisted_21 = { class: "text-h5 font-weight-bold" }
const _hoisted_22 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_23 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_24 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_25 = {
  key: 0,
  class: "pa-3 d-flex align-center ga-2",
  style: {"background":"rgba(var(--v-theme-on-surface), 0.03)"}
}
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { style: {"min-width":"120px"} }
const _hoisted_28 = { class: "d-flex align-center ga-2" }
const _hoisted_29 = {
  class: "text-caption",
  style: {"min-width":"32px"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  colspan: "6",
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_32 = { class: "text-medium-emphasis" }
const _hoisted_33 = {
  key: 0,
  class: "text-caption text-warning"
}
const _hoisted_34 = {
  key: 1,
  class: "text-medium-emphasis"
}
const _hoisted_35 = { class: "text-medium-emphasis" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  colspan: "6",
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_38 = { class: "d-flex ga-1 flex-wrap" }
const _hoisted_39 = { style: {"min-width":"120px"} }
const _hoisted_40 = { class: "d-flex align-center ga-2" }
const _hoisted_41 = {
  class: "text-caption",
  style: {"min-width":"48px"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  colspan: "5",
  class: "text-center text-medium-emphasis pa-6"
}

import {computed, nextTick, ref} from 'vue'
import {useDisplay} from 'vuetify'
import {State, StateColor, StateDescription} from '@/types/Order'


export default /*@__PURE__*/_defineComponent({
  __name: 'Test',
  setup(__props) {

const display = useDisplay()
const activeTab = ref('orders')
const stateFilter = ref<string | null>(null)
const detailCard = ref<HTMLElement | null>(null)

const chartSize = computed(() => display.smAndDown.value ? 200 : 240)
const legendConfig = computed(() => ({
  position: display.mdAndUp.value ? 'bottom' : 'bottom'
}))

// =====================================================
// DUMMY DATEN — Stillstand 2612
// =====================================================

const outage = {
  code: '2612',
  name: 'Jahresstillstand PM3 Sommer 2025',
  description: 'Großer geplanter Stillstand für Revision und Wartungsarbeiten an PM3. Schwerpunkte: Trockenpartie, Pressenpartie und Antriebe.',
  scheduled_start: '2025-07-06T06:00:00',
  scheduled_end: '2025-11-22T18:00:00',
  planned_hours: 37,
}

const orders = [
  {id: 4001, title: 'Pressenwalze tauschen', work_group: 'TDM-PM3', state: 'BEEND', priority: '2', progress: 100},
  {id: 4002, title: 'Trockengruppe 3 — Lager prüfen', work_group: 'TDM-PM3', state: 'INBEARB', priority: '2', progress: 60},
  {id: 4003, title: 'E-Antriebe Sektion 5 Revision', work_group: 'TDE-PM3', state: 'TERM', priority: '1', progress: 0},
  {id: 4004, title: 'SPS-Programm Update Rollenwickler', work_group: 'TDE-PM3', state: 'BEEND', priority: '3', progress: 100},
  {id: 4005, title: 'Dampfleitung Isolation erneuern', work_group: 'TDM-PM3', state: 'ANFO', priority: '3', progress: 0},
]

const tasks = [
  {order_id: 4001, id: 1, title: 'Alte Walze demontieren', assignee: 'beckm', state: 'BEEND', is_lockout: false, scheduled_duration: '4h'},
  {order_id: 4001, id: 2, title: 'Freischaltung Pressenpartie', assignee: 'weberk', state: 'BEEND', is_lockout: true, scheduled_duration: '1h'},
  {order_id: 4001, id: 3, title: 'Neue Walze einbauen', assignee: 'beckm', state: 'BEEND', is_lockout: false, scheduled_duration: '6h'},
  {order_id: 4001, id: 4, title: 'Ausrichten & Probelauf', assignee: 'beckm', state: 'BEEND', is_lockout: false, scheduled_duration: '3h'},
  {order_id: 4002, id: 1, title: 'Lagertemperatur messen', assignee: 'schmidth', state: 'BEEND', is_lockout: false, scheduled_duration: '2h'},
  {order_id: 4002, id: 2, title: 'Lagerspiel prüfen', assignee: 'schmidth', state: 'BEEND', is_lockout: false, scheduled_duration: '1.5h'},
  {order_id: 4002, id: 3, title: 'Schmierstoffwechsel', assignee: 'schmidth', state: 'INBEARB', is_lockout: false, scheduled_duration: '2h'},
  {order_id: 4002, id: 4, title: 'Prüfprotokoll erstellen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '1h'},
  {order_id: 4003, id: 1, title: 'Freischaltung E-Antriebe Sek. 5', assignee: 'weberk', state: 'TERM', is_lockout: true, scheduled_duration: '1h'},
  {order_id: 4003, id: 2, title: 'Motor 5.1 ausbauen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '3h'},
  {order_id: 4003, id: 3, title: 'Motor 5.2 Wicklung prüfen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '2h'},
  {order_id: 4003, id: 4, title: 'Motor 5.1 einbauen & verdrahten', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '4h'},
  {order_id: 4003, id: 5, title: 'Schutzprüfung durchführen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '1.5h'},
  {order_id: 4004, id: 1, title: 'Backup altes Programm', assignee: 'muellerj', state: 'BEEND', is_lockout: false, scheduled_duration: '0.5h'},
  {order_id: 4004, id: 2, title: 'Neues Programm aufspielen', assignee: 'muellerj', state: 'BEEND', is_lockout: false, scheduled_duration: '2h'},
  {order_id: 4004, id: 3, title: 'Funktionstest Wickler', assignee: 'muellerj', state: 'BEEND', is_lockout: false, scheduled_duration: '1.5h'},
  {order_id: 4005, id: 1, title: 'Alte Isolation entfernen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '3h'},
  {order_id: 4005, id: 2, title: 'Rohrleitung prüfen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '2h'},
  {order_id: 4005, id: 3, title: 'Neue Isolation anbringen', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '4h'},
  {order_id: 4005, id: 4, title: 'Dichtheitsprüfung', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '1h'},
  {order_id: 4002, id: 5, title: 'Lager nachbestellen (Ersatz)', assignee: 'schmidth', state: 'WMAT', is_lockout: false, scheduled_duration: null},
  {order_id: 4003, id: 6, title: 'Frequenzumrichter FU5.1 parametrieren', assignee: null, state: 'ANFO', is_lockout: false, scheduled_duration: '2h'},
]

const checklists = [
  {id: 1, title: 'Sicherheits-Checkliste Pressenpartie', assignees: ['weberk', 'beckm'], state: 'BEEND', checked: 8, total: 8, progress: 100},
  {id: 2, title: 'Qualitätsprüfung Trockengruppe 3', assignees: ['schmidth'], state: 'INBEARB', checked: 4, total: 10, progress: 40},
  {id: 3, title: 'Abnahmeprotokoll E-Antriebe Sek. 5', assignees: ['weberk'], state: 'ANFO', checked: 0, total: 12, progress: 0},
]

// =====================================================
// COMPUTED: Chart items
// =====================================================

function buildStateChart(items: { state: string }[]) {
  const counts: Record<string, number> = {}
  items.forEach(i => {
    counts[i.state] = (counts[i.state] || 0) + 1
  })
  return Object.entries(counts)
      .filter(([, c]) => c > 0)
      .map(([state, count]) => ({
        id: state,
        title: StateDescription[state as State] ?? state,
        value: count,
        color: StateColor[state as State] ?? '#9E9E9E',
        pattern: state === 'ANFO' ? 'url(#pattern-0)' : '',
      }))
}

const orderChartItems = computed(() => buildStateChart(orders))
const taskChartItems = computed(() => buildStateChart(tasks))
const checklistChartItems = computed(() => buildStateChart(checklists))

// =====================================================
// FILTER by State (click on chart/legend → jump to list)
// =====================================================

function filterByState(tab: string, state: string) {
  activeTab.value = tab
  stateFilter.value = state
  nextTick(() => {
    const el = (detailCard.value as any)?.$el ?? detailCard.value
    el?.scrollIntoView({behavior: 'smooth', block: 'start'})
  })
}

function clearFilter() {
  stateFilter.value = null
}

function onPieClick(event: MouseEvent, tab: string, chartItems: ReturnType<typeof buildStateChart>) {
  // Walk up to find the <g class="v-pie-segment"> wrapper
  let el = event.target as HTMLElement | null
  while (el && !el.classList?.contains('v-pie-segment')) {
    el = el.parentElement
  }
  if (!el?.parentElement) return

  // Index of this segment among siblings = index in chartItems
  const segments = Array.from(el.parentElement.children)
      .filter(c => c.classList.contains('v-pie-segment'))
  const index = segments.indexOf(el)

  if (index >= 0 && index < chartItems.length) {
    filterByState(tab, chartItems[index].id)
  }
}

const filteredOrders = computed(() =>
    stateFilter.value ? orders.filter(o => o.state === stateFilter.value) : orders
)
const filteredTasks = computed(() =>
    stateFilter.value ? tasks.filter(t => t.state === stateFilter.value) : tasks
)
const filteredChecklists = computed(() =>
    stateFilter.value ? checklists.filter(c => c.state === stateFilter.value) : checklists
)

// Gesamtfortschritt
const completedTasks = computed(() => tasks.filter(t => t.state === 'BEEND' || t.state === 'GESCHL').length)
const totalTasks = computed(() => tasks.length)
const totalProgress = computed(() => Math.round((completedTasks.value / totalTasks.value) * 100))
const progressColor = computed(() => {
  if (totalProgress.value >= 80) return '#4CAF50'
  if (totalProgress.value >= 40) return '#1976D2'
  return '#FF9800'
})

// =====================================================
// HELPER
// =====================================================

function formatDate(dateStr: string | null): string {
  if (!dateStr) return '?'
  return new Date(dateStr).toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
}

function getPriorityColor(p: string): string {
  switch (p) {
    case '1': return '#D32F2F'
    case '2': return '#FF9800'
    case '3': return '#1976D2'
    case '4': return '#9E9E9E'
    default: return '#9E9E9E'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pie = _resolveComponent("v-pie")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pa-4 pa-md-6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          elevation: "1",
          class: "pa-5 mb-6"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-power",
                    size: "28",
                    color: "primary"
                  }),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(outage.code), 1)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(outage.name), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      icon: "mdi-calendar-range"
                    }),
                    _createElementVNode("span", null, _toDisplayString(formatDate(outage.scheduled_start)), 1),
                    _createVNode(_component_v_icon, {
                      size: "14",
                      icon: "mdi-arrow-right"
                    }),
                    _createElementVNode("span", null, _toDisplayString(formatDate(outage.scheduled_end)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      icon: "mdi-clock-outline"
                    }),
                    _createElementVNode("span", null, _toDisplayString(outage.planned_hours) + "h geplant", 1)
                  ]),
                  (outage.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          icon: "mdi-text",
                          class: "mt-1"
                        }),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(outage.description), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Gesamtfortschritt", -1)),
                _createElementVNode("div", {
                  class: "text-h4 font-weight-bold",
                  style: _normalizeStyle({ color: progressColor.value })
                }, _toDisplayString(totalProgress.value) + "% ", 5),
                _createVNode(_component_v_progress_linear, {
                  "model-value": totalProgress.value,
                  color: progressColor.value,
                  height: "8",
                  rounded: "",
                  class: "mt-2"
                }, null, 8, ["model-value", "color"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(completedTasks.value) + " erledigt", 1),
                  _createElementVNode("span", null, _toDisplayString(totalTasks.value) + " gesamt", 1)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "mb-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  rounded: "xl",
                  elevation: "1",
                  class: "pa-5 h-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-clipboard-text-multiple-outline",
                        size: "20",
                        color: "primary"
                      }),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "Aufträge", -1)),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(orders.length), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_pie, {
                      items: orderChartItems.value,
                      size: chartSize.value,
                      legend: legendConfig.value,
                      "inner-cut": "65",
                      gap: "2",
                      rounded: "2",
                      "item-key": "id",
                      "hide-slice": "",
                      animation: "",
                      reveal: "",
                      tooltip: "",
                      class: "justify-center pie-clickable",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onPieClick($event, 'orders', orderChartItems.value)))
                    }, {
                      center: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(orders.length), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "opacity-60 text-caption" }, "Aufträge", -1))
                        ])
                      ]),
                      legend: _withCtx(({ items }) => [
                        _createVNode(_component_v_list, {
                          class: "py-0 bg-transparent",
                          density: "compact"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: item.key,
                                title: item.title,
                                subtitle: `${item.value} Auftr.`,
                                rounded: "lg",
                                link: "",
                                slim: "",
                                onClick: ($event: any) => (filterByState('orders', item.key))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: item.color,
                                    size: 12,
                                    class: "me-2"
                                  }, null, 8, ["color"])
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    icon: "mdi-arrow-right",
                                    class: "opacity-40"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["title", "subtitle", "onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["items", "size", "legend"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  rounded: "xl",
                  elevation: "1",
                  class: "pa-5 h-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-wrench-outline",
                        size: "20",
                        color: "primary"
                      }),
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "Aufgaben", -1)),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tasks.length), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_pie, {
                      items: taskChartItems.value,
                      size: chartSize.value,
                      legend: legendConfig.value,
                      "inner-cut": "65",
                      gap: "2",
                      rounded: "2",
                      "item-key": "id",
                      "hide-slice": "",
                      animation: "",
                      reveal: "",
                      tooltip: "",
                      class: "justify-center pie-clickable",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onPieClick($event, 'tasks', taskChartItems.value)))
                    }, {
                      center: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(tasks.length), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "opacity-60 text-caption" }, "Aufgaben", -1))
                        ])
                      ]),
                      legend: _withCtx(({ items }) => [
                        _createVNode(_component_v_list, {
                          class: "py-0 bg-transparent",
                          density: "compact"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: item.key,
                                title: item.title,
                                subtitle: `${item.value} Aufg.`,
                                rounded: "lg",
                                link: "",
                                slim: "",
                                onClick: ($event: any) => (filterByState('tasks', item.key))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: item.color,
                                    size: 12,
                                    class: "me-2"
                                  }, null, 8, ["color"])
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    icon: "mdi-arrow-right",
                                    class: "opacity-40"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["title", "subtitle", "onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["items", "size", "legend"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  rounded: "xl",
                  elevation: "1",
                  class: "pa-5 h-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-format-list-checks",
                        size: "20",
                        color: "primary"
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "Checklisten", -1)),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(checklists.length), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_pie, {
                      items: checklistChartItems.value,
                      size: chartSize.value,
                      legend: legendConfig.value,
                      "inner-cut": "65",
                      gap: "2",
                      rounded: "2",
                      "item-key": "id",
                      "hide-slice": "",
                      animation: "",
                      reveal: "",
                      tooltip: "",
                      class: "justify-center pie-clickable",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onPieClick($event, 'checklists', checklistChartItems.value)))
                    }, {
                      center: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(checklists.length), 1),
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "opacity-60 text-caption" }, "Checkl.", -1))
                        ])
                      ]),
                      legend: _withCtx(({ items }) => [
                        _createVNode(_component_v_list, {
                          class: "py-0 bg-transparent",
                          density: "compact"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: item.key,
                                title: item.title,
                                subtitle: `${item.value} Checkl.`,
                                rounded: "lg",
                                link: "",
                                slim: "",
                                onClick: ($event: any) => (filterByState('checklists', item.key))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: item.color,
                                    size: 12,
                                    class: "me-2"
                                  }, null, 8, ["color"])
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    icon: "mdi-arrow-right",
                                    class: "opacity-40"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["title", "subtitle", "onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["items", "size", "legend"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          ref_key: "detailCard",
          ref: detailCard,
          rounded: "xl",
          elevation: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event)),
              color: "primary",
              grow: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "orders" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      icon: "mdi-clipboard-text-multiple-outline",
                      size: "18"
                    }),
                    _createTextVNode(" Aufträge (" + _toDisplayString(filteredOrders.value.length), 1),
                    (stateFilter.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "/" + _toDisplayString(orders.length), 1))
                      : _createCommentVNode("", true),
                    _cache[12] || (_cache[12] = _createTextVNode(") "))
                  ]),
                  _: 1,
                  __: [12]
                }),
                _createVNode(_component_v_tab, { value: "tasks" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      icon: "mdi-wrench-outline",
                      size: "18"
                    }),
                    _createTextVNode(" Aufgaben (" + _toDisplayString(filteredTasks.value.length), 1),
                    (stateFilter.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "/" + _toDisplayString(tasks.length), 1))
                      : _createCommentVNode("", true),
                    _cache[13] || (_cache[13] = _createTextVNode(") "))
                  ]),
                  _: 1,
                  __: [13]
                }),
                _createVNode(_component_v_tab, { value: "checklists" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      start: "",
                      icon: "mdi-format-list-checks",
                      size: "18"
                    }),
                    _createTextVNode(" Checklisten (" + _toDisplayString(filteredChecklists.value.length), 1),
                    (stateFilter.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "/" + _toDisplayString(checklists.length), 1))
                      : _createCommentVNode("", true),
                    _cache[14] || (_cache[14] = _createTextVNode(") "))
                  ]),
                  _: 1,
                  __: [14]
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (stateFilter.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    icon: "mdi-filter",
                    class: "text-medium-emphasis"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "Gefiltert nach:", -1)),
                  _createVNode(_component_v_chip, {
                    size: "small",
                    color: _unref(StateColor)[stateFilter.value as State],
                    variant: "flat",
                    label: "",
                    closable: "",
                    "onClick:close": clearFilter
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(StateDescription)[stateFilter.value as State] ?? stateFilter.value), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_tabs_window, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs_window_item, { value: "orders" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, {
                      hover: "",
                      density: "comfortable",
                      class: "detail-table"
                    }, {
                      default: _withCtx(() => [
                        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "ID"),
                            _createElementVNode("th", null, "Titel"),
                            _createElementVNode("th", null, "Gruppe"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Priorität"),
                            _createElementVNode("th", null, "Fortschritt")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOrders.value, (order) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: order.id,
                              class: "cursor-pointer"
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  label: "",
                                  border: "thin opacity-25",
                                  "prepend-icon": "mdi-clipboard-text-outline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(order.id), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(order.title), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(order.work_group), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  color: _unref(StateColor)[order.state as State],
                                  variant: "flat",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(StateDescription)[order.state as State] ?? order.state), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_26, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  color: getPriorityColor(order.priority),
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" P" + _toDisplayString(order.priority), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_v_progress_linear, {
                                    "model-value": order.progress,
                                    color: order.progress === 100 ? '#4CAF50' : '#1976D2',
                                    height: "6",
                                    rounded: "",
                                    style: {"flex":"1"}
                                  }, null, 8, ["model-value", "color"]),
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(order.progress) + "%", 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (filteredOrders.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                                _createElementVNode("td", _hoisted_31, " Keine Aufträge mit Status „" + _toDisplayString(_unref(StateDescription)[stateFilter.value as State] ?? stateFilter.value) + "\" ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1,
                      __: [16]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, { value: "tasks" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, {
                      hover: "",
                      density: "comfortable",
                      class: "detail-table"
                    }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Auftr."),
                            _createElementVNode("th", null, "ID"),
                            _createElementVNode("th", null, "Titel"),
                            _createElementVNode("th", null, "Zugewiesen"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Dauer")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTasks.value, (task) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `${task.order_id}-${task.id}`,
                              class: "cursor-pointer"
                            }, [
                              _createElementVNode("td", _hoisted_32, _toDisplayString(task.order_id), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  label: "",
                                  border: "thin opacity-25",
                                  "prepend-icon": "mdi-wrench-outline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(task.id), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, _toDisplayString(task.title), 1),
                                (task.is_lockout)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _createVNode(_component_v_icon, {
                                        size: "12",
                                        icon: "mdi-lightning-bolt"
                                      }),
                                      _cache[17] || (_cache[17] = _createTextVNode(" Freischaltung "))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, [
                                (task.assignee)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "small",
                                      variant: "tonal",
                                      "prepend-icon": "mdi-account"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(task.assignee), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_34, "—"))
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  color: _unref(StateColor)[task.state as State],
                                  variant: "flat",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(StateDescription)[task.state as State] ?? task.state), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_35, _toDisplayString(task.scheduled_duration ?? '—'), 1)
                            ]))
                          }), 128)),
                          (filteredTasks.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                _createElementVNode("td", _hoisted_37, " Keine Aufgaben mit Status „" + _toDisplayString(_unref(StateDescription)[stateFilter.value as State] ?? stateFilter.value) + "\" ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1,
                      __: [18]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, { value: "checklists" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, {
                      hover: "",
                      density: "comfortable",
                      class: "detail-table"
                    }, {
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "ID"),
                            _createElementVNode("th", null, "Titel"),
                            _createElementVNode("th", null, "Zugewiesen"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Fortschritt")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredChecklists.value, (cl) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: cl.id,
                              class: "cursor-pointer"
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  label: "",
                                  border: "thin opacity-25",
                                  "prepend-icon": "mdi-format-list-checks"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cl.id), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(cl.title), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cl.assignees, (a) => {
                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                      key: a,
                                      size: "small",
                                      variant: "tonal",
                                      "prepend-icon": "mdi-account"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(a), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  size: "small",
                                  color: _unref(StateColor)[cl.state as State],
                                  variant: "flat",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(StateDescription)[cl.state as State] ?? cl.state), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_v_progress_linear, {
                                    "model-value": cl.progress,
                                    color: cl.progress === 100 ? '#4CAF50' : '#1976D2',
                                    height: "6",
                                    rounded: "",
                                    style: {"flex":"1"}
                                  }, null, 8, ["model-value", "color"]),
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(cl.checked) + "/" + _toDisplayString(cl.total), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (filteredChecklists.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                _createElementVNode("td", _hoisted_43, " Keine Checklisten mit Status „" + _toDisplayString(_unref(StateDescription)[stateFilter.value as State] ?? stateFilter.value) + "\" ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1,
                      __: [19]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "h-0" }, [
      _createElementVNode("svg", {
        height: "0",
        version: "1.1",
        width: "0",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("defs", null, [
          _createElementVNode("pattern", {
            id: "pattern-0",
            height: "20",
            patternTransform: "rotate(145) scale(.2)",
            patternUnits: "userSpaceOnUse",
            width: "20"
          }, [
            _createElementVNode("path", {
              d: "M0 10h20zm0 20h20zm0 20h20zm0 20h20z",
              fill: "none",
              stroke: "rgb(var(--v-theme-surface))",
              "stroke-width": "3"
            })
          ])
        ])
      ])
    ], -1))
  ], 64))
}
}

})